export default {
  oldPassword: "Stare hasło",
  newPassword: "Nowe hasło",
  confirmNewPassword: "Powtórzenie nowego hasła",
  numeric: "musi zawierać tylko cyfry",
  lastName: "Nazwisko",
  firstName: "Imię",
  email: "Email",
  name: "Nazwa",
  required: "jest wymagane",
  invalid: "ma nieprawidłowy format",
  min: "jest za krótkie",
  minValue: "jest zbyt małe",
  maxValue: "jest zbyt duże",
  max: "jest za długie",
  matchNewPassword: "musi być identyczne jak Nowe hasło",
  invalidCurrentPassword: "jest nieprawidłowe",
  atLeastOne: "musi zawierać co najmniej jeden element",
  takenEmail: "jest już zajęty",
  questions:
    "Każde pytanie musi posiadać wypełnioną treść oraz co najmniej jedną odpowiedź",
};
